import { useEffect, useState } from "react";
import { Phone, X } from "lucide-react";
import { COMPANY } from "@/content";
import { AlertDialog, AlertDialogContent, AlertDialogTitle, AlertDialogDescription, AlertDialogCancel, AlertDialogAction } from "@/components/ui/alert-dialog";

export default function CallLink({ className, children, ...rest }) {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (open) return;
    const t = setTimeout(() => { document.body.style.pointerEvents = ""; }, 350);
    return () => clearTimeout(t);
  }, [open]);

  const proceed = () => {
    setOpen(false);
    try {
      const a = document.createElement("a");
      a.href = COMPANY.phoneHref;
      a.rel = "noopener";
      document.body.appendChild(a);
      a.click();
      a.remove();
    } catch {
      try { window.location.assign(COMPANY.phoneHref); } catch { /* embed blocked tel: navigation */ }
    }
  };

  return (
    <>
      <a href={COMPANY.phoneHref} onClick={(e) => { e.preventDefault(); setOpen(true); }} className={className} {...rest}>
        {children}
      </a>
      <AlertDialog open={open} onOpenChange={setOpen}>
        <AlertDialogContent data-testid="call-confirm-dialog" className="max-w-sm rounded-3xl border-sand bg-bone p-7 text-center">
          <span className="mx-auto grid place-items-center h-14 w-14 rounded-full bg-terracotta text-bone"><Phone size={24} /></span>
          <AlertDialogTitle className="font-heading text-2xl text-charcoal mt-2">Call {COMPANY.full}?</AlertDialogTitle>
          <AlertDialogDescription className="text-ink">
            <span className="block font-heading text-3xl text-terracotta-dark tracking-tight">{COMPANY.phone}</span>
            <span className="block text-sm mt-1">Serving Fort Myers, Estero, Naples &amp; Bonita Springs</span>
          </AlertDialogDescription>
          <div className="mt-4 grid grid-cols-2 gap-3">
            <AlertDialogCancel data-testid="call-cancel-btn" className="mt-0 inline-flex items-center justify-center gap-2 rounded-full border border-sand bg-white px-5 py-3 font-semibold text-charcoal hover:bg-sand">
              <X size={16} /> Cancel
            </AlertDialogCancel>
            <AlertDialogAction data-testid="call-proceed-btn" onClick={proceed} className="inline-flex items-center justify-center gap-2 rounded-full bg-terracotta px-5 py-3 font-semibold text-bone hover:bg-terracotta-dark">
              <Phone size={16} /> Call Now
            </AlertDialogAction>
          </div>
        </AlertDialogContent>
      </AlertDialog>
    </>
  );
}
